import Image from "next/image";
import Google from "../../assets/brands/google-calendar.svg";
import GoogleCalendar from "../../assets/images/calendar-image.png";

const GoogleCard = () => {
  return (
    <div className="bg-white border border-black border-dashed rounded-[28px] w-[365px] h-[305px] relative overflow-hidden">
      <div className="w-[90%] flex items-center gap-3.5 pl-6 pt-[18px]">
        <Image src={Google} alt="google" />
        <div className="text-sm font-semibold max-sm:w-[60%]">
          Get study reminders and never miss a review session again.
        </div>
      </div>

      <Image
        src={GoogleCalendar}
        alt="google-calendar"
        className="absolute max-sm:top-[70%] top-[60%] left-[70%] sm:left-[60%] -translate-x-1/2 -translate-y-1/2"
      />
    </div>
  );
};

const GoogleFeatureCard = () => {
  return (
    <div className="bg-[#FEC492] rounded-[32px] w-[300px] h-[500px] sm:w-[330px] sm:h-[550px] md:w-[360px] md:h-[600px] py-6 flex flex-col relative items-center border border-black border-dashed overflow-hidden">
      <h2 className="text-black text-[24px] sm:text-[26px] md:text-[28px] font-bold text-center mb-6 sm:mb-8 font-poppins">
        Google Calendar
      </h2>
      <div className="absolute top-1/2 left-[70%] sm:left-[60%] -translate-x-1/2 -translate-y-1/2">
        <GoogleCard />
      </div>
    </div>
  );
};

export default GoogleFeatureCard;
